import Api from './Api';

export const dashboardCounts = async () =>
  await Api.http({
    method: 'get',
    url: `/admin/dashboard/counts`,
  });